import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ModalService } from './ModalService';
import { NgComponentOutlet } from '@angular/common';

@Component({
  selector: 'app-mksoft-global-modal-service',
  imports: [NgComponentOutlet],
  templateUrl: './globalModalService.html',
  styleUrl: './globalModalService.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlobalModalService {
  readonly modalService = inject(ModalService);
}
